import { francePAEn } from "./francePAEn";

const documents = {
  acknowledge_document: "Acknowledge {{documentClass}}",
  acknowledge_document_subtitle:
    "Add a note before agreeing or disagreeing with this {{documentClass}}",
  note: "Note",
  note_max_length: "Note cannot exceed 500 characters",
  agree: "Agree",
  disagree: "Disagree",
  document_acknowledged_successfully: "Document acknowledged successfully",
  agreed: "Agreed",
  disagreed: "Disagreed",
  acknowledgment_details: "Acknowledgment details",
  acknowledged_by: "Acknowledged by",
  acknowledged_on: "Acknowledged on",
  upload_via_qr_code: "Upload via QR Code",
  scan_this_qr_code_to_download_dost_app: `Scan this QR code to download the app. `,
  scan_the_qr_code_to_instantly_upload_your_documents_with_the_dost_app: `Scan the QR code to instantly upload your documents with the Dost app.`,
  click_the_button_below_to_download: `Click the button below to download the app.`,
  dont_have_the_dost_app: "Don't have the Dost app?",
  or: "Or",
  no_: "No.",
  document_date: "Document date",
  vendor_address: "Vendor address",
  code: "Code",
  description: "Description",
  purchase_order: "Purchase order",
  delivery_note: "Delivery note",
  quantity: "Quantity",
  unit_price: "Unit price",
  discount: "Discount",
  amount: "Amount",
  vat: "VAT",
  subtotal: "Subtotal",
  total_without_tax: "Total (without tax)",
  total_tax: "Total tax",
  total: "Total",
  use_the_dost_upload_app_to_scan_documents_and_send_them_directly_to_your_portal: `Use the Dost Upload App to scan documents and send them directly to your portal.`,
  steps_to_scan_qr: `Steps to Scan QR`,
  open_dost_upload_app_on_your_phone: `Open Dost Upload App on your phone`,
  select_the_camera_option: `Select the Camera option`,
  take_a_photo_and_edit_if_necessary: `Take a photo and edit if necessary`,
  scan_this_qr_code_to_send_to_dost_portal: `Scan this QR code to send to Dost portal`,
  dont_have_the_dost_upload_app: `Don't Have the Dost Upload App?`,
  scan_this_qr_code_to_download_the_app: `Scan this QR code to download the app.`,
  download_dost_upload_app_android: `Download Dost Upload App (Android)`,
  upload_documents_from_device: `Upload documents from device`,
  drag_and_drop_your_files_or_click_to_browse: `Drag and drop your files or click to browse`,
  no_document_uploaded: `No document uploaded`,
  duplicate_files_are_not_allowed: `Duplicate documents detected`,
  files_cannot_be_more_than_10: `Files cannot be more than 10`,
  document_uploaded_successfully: `Document uploaded successfully`,
  document_upload_unsuccessful: `Document upload unsuccessful`,
  receive_via_invitation_subtitle: `Invite your {{entity}} to the Dost {{portalName}} Portal where they can log in and upload documents directly.`,
  send_invites: `Send invites`,
  receive_via_customers_portal: `Receive via Customer Portal`,
  customers_uploads_directly_in_customers_portal: `Customer uploads directly in Customer Portal`,
  receive_via_suppliers_portal: `Receive via Supplier Portal`,
  suppliers_uploads_directly_in_suppliers_portal: `Supplier uploads directly in Supplier Portal`,
  pay_invoices: `Pay Invoices`,
  export: `Export`,
  statusCode: "Status code",
  statusName: "Status Name",
  rejectionReason: "Rejection reason",
  direction: `Direction`,
  sendStatus: `Send status`,
  "E-Invoice Status": "E-Invoice Status",
  apply: "Apply",
  document_upload_via_qr: `Document Upload via QR`,
  ...francePAEn,
};
export default documents;
